/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';

/**
 * MaterialRounded Campaign.
 * @export
 */

export const ICON_CAMPAIGN = (
  <svg fill="none" height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15 10.0039C15 10.4622 15.375 10.8372 15.8333 10.8372H17.5C17.9583 10.8372 18.3333 10.4622 18.3333 10.0039C18.3333 9.54553 17.9583 9.17053 17.5 9.17053H15.8333C15.375 9.17053 15 9.54553 15 10.0039Z"
      fill="#4F4F4F"
    />
    <path
      d="M13.825 14.0205C13.55 14.3872 13.625 14.8955 13.9916 15.1622C14.4333 15.4872 14.9 15.8372 15.3416 16.1705C15.7083 16.4455 16.225 16.3705 16.4916 16.0039C16.4916 15.9955 16.5 15.9955 16.5 15.9872C16.775 15.6205 16.7 15.1039 16.3333 14.8372C15.8916 14.5039 15.425 14.1539 14.9916 13.8289C14.625 13.5539 14.1083 13.6372 13.8333 14.0039C13.8333 14.0122 13.825 14.0205 13.825 14.0205Z"
      fill="#4F4F4F"
    />
    <path
      d="M16.5083 4.0122C16.5083 4.00386 16.5 4.00386 16.5 3.99553C16.225 3.62886 15.7083 3.55386 15.35 3.82886C14.9083 4.1622 14.4333 4.5122 14 4.84553C13.6333 5.12053 13.5666 5.6372 13.8416 5.99553C13.8416 6.00386 13.85 6.00386 13.85 6.0122C14.125 6.37886 14.6333 6.45386 15 6.17886C15.4416 5.85386 15.9083 5.49553 16.35 5.1622C16.7083 4.89553 16.775 4.37886 16.5083 4.0122Z"
      fill="#4F4F4F"
    />
    <path
      d="M6.66663 7.50386H3.33329C2.41663 7.50386 1.66663 8.25386 1.66663 9.17053V10.8372C1.66663 11.7539 2.41663 12.5039 3.33329 12.5039H4.16663V15.0039C4.16663 15.4622 4.54163 15.8372 4.99996 15.8372C5.45829 15.8372 5.83329 15.4622 5.83329 15.0039V12.5039H6.66663L10.8333 15.0039V5.00386L6.66663 7.50386Z"
      fill="#4F4F4F"
    />
    <path
      d="M12.9166 10.0039C12.9166 8.89553 12.4333 7.89553 11.6666 7.2122V12.7872C12.4333 12.1122 12.9166 11.1122 12.9166 10.0039Z"
      fill="#4F4F4F"
    />
  </svg>
);
